module.exports = __webpack_public_path__ + "static/media/buyer_left_put_2x.b54fc767.png";